import { createSelector } from 'reselect';
import { RootState } from 'store';
import { Option } from 'types/Generics';
import { IntakeFormCustomQuestionCategory } from 'types/IntakeForm';
import { PetTypeId, PetTypeIds } from 'types/Pet';

export const getMarketplaceState = (state: RootState) => state.marketplace;

export const getMarketplace = createSelector(
    (state: RootState) => state.marketplace,
    marketplace => marketplace.data
);

export const getMarketplaceDeposit = createSelector(
    [getMarketplace],
    marketplace => marketplace.deposit
);

export const getPetSizes = createSelector(
    [
        (state: RootState) => state.marketplace.data.petTypes,
        (state: RootState, petType: PetTypeId) => petType
    ],
    (petTypes, petType) => petTypes[petType].sizes
);

export const getMarketplaceExoticTypes = createSelector(
    [(state: RootState) => state.marketplace.data.petTypes],
    (petTypes): Array<Option<string>> => {
        const exotics = petTypes[PetTypeIds.EXOTIC];
        const types = (exotics.types ?? []).map(type => ({
            id: type.id,
            name: type.name,
            description: type.description
        }));
        const others = (exotics.others ?? []).map(name => ({
            id: name,
            name
        }));

        return [...types, ...others];
    }
);

export const getPetHairLengths = createSelector(
    [
        (state: RootState) => state.marketplace.data.petTypes,
        (state: RootState, petType: PetTypeId) => petType
    ],
    (petTypes, petType) => petTypes[petType].hairLengths
);

export const getOnlineBookingPreferences = createSelector(
    [getMarketplace],
    marketplace => marketplace.onlineBookingPreferences
);

export const getIntakeFormCustomerQuestions = createSelector([getMarketplace], marketplace =>
    marketplace.intakeFormPreferences.questionsEnabled &&
    marketplace.intakeFormPreferences.questions
        ? marketplace.intakeFormPreferences.questions.filter(
              question => question.category === IntakeFormCustomQuestionCategory.FOR_CUSTOMER
          )
        : undefined
);

export const getIntakeFormPetQuestions = createSelector([getMarketplace], marketplace =>
    marketplace.intakeFormPreferences.questionsEnabled &&
    marketplace.intakeFormPreferences.questions
        ? marketplace.intakeFormPreferences.questions.filter(
              question => question.category === IntakeFormCustomQuestionCategory.FOR_PET
          )
        : undefined
);

export const getGaTrackingId = createSelector(
    [getMarketplace],
    marketplace => marketplace.gaTrackingId
);

export const getGtmTrackingId = createSelector(
    [getMarketplace],
    marketplace => marketplace.gtmTrackingId
);
